// import { NavLinkStyle } from "../Components/NavLinkStyle";
import { NavLink, Outlet } from "react-router-dom";
import { NavLinkStyle } from "../Components/NavLinkStyle";

export const TradeCurrency = () => {
  return (
    <div className=" bg-b-bk flex flex-col gap-16 font-pin">
      <div className=" flex flex-col border-l-hf  bg-t-wh ">
        <div className="py-8 text-p-bk ">
          <h2 className="font-semibold font-pin text-xl text-center">
            P2p and Direct Trade
          </h2>
        </div>
        <nav className="flex flex-row items-center bg-p-wh drop-shadow">
          <NavLink to="p2p" className={NavLinkStyle}>
            P2P Trade
          </NavLink>
          <NavLink to="direct" className={NavLinkStyle}>
            Direct Trade
          </NavLink>
        </nav>
      </div>
      <div className=" text-p-bk ">{<Outlet />}</div>
    </div>
  );
};
